import { useSWRFetch } from '@hooks/useSWRFetch';
import { TEN_MINUTES_IN_MS } from '@helpers/constants';
import { UnassociatedVideosResult } from './types';

export enum Filter {
  // Return all unassociated videos
  ALL = 0,
  // Return only unassociated videos with related ISRC
  VIDEOS_WITH_RELATED_ISRC = 1,
  // Return only unassociated videos without related ISRC
  VIDEOS_WITHOUT_RELATED_ISRC = 2,
}

export const useShowUnassociatedVideos = (
  page: number,
  limit: number,
  filter: Filter,
  enrichTracks: boolean = false,
): UnassociatedVideosResult => {
  const searchParams = new URLSearchParams();
  searchParams.append('pagination.page', page.toString());
  searchParams.append('pagination.page_size', limit.toString());
  searchParams.append('enrichTracks', enrichTracks.toString());
  searchParams.append('filter', filter.toString());
  const requestObject = {
    url: `v1/unassociatedVideos?${new URLSearchParams(searchParams)}`,
  };

  const canRequest = page >= 1 && limit >= 1;
  const { data, error, isValidating, isLoading, status, mutate } =
    useSWRFetch<UnassociatedVideosResult>(canRequest ? requestObject : null, {
      dedupingInterval: TEN_MINUTES_IN_MS,
    });

  return {
    data,
    error,
    isValidating,
    isLoading,
    status,
    mutate,
  };
};

export const useShowUnassociatedVideoFlag = () => {
  const { data, status, isLoading } = useShowUnassociatedVideos(
    1,
    1,
    Filter.VIDEOS_WITH_RELATED_ISRC,
  );
  if (status === 200) {
    const hasUnassociatedVideos =
      data.unassociatedVideos.length > 0 ? true : false;
    return {
      doShow: hasUnassociatedVideos,
      isLoading,
    };
  }

  return { doShow: false, isLoading };
};
